export default __webpack_public_path__ + "static/top-051948ebb5476e300a3aa33da2a671b3.jpg";